import { fetchCurrentUser } from '../../ducks/user.duck';

export const loadData = () => (dispatch, getState, sdk) => dispatch(fetchCurrentUser());

const initialState = {};

export default function ingresosPageReducer(state = initialState) {
  return state;
}
